// src/features/auth/signup/SocialButtons.jsx
import React from 'react';
import { AiOutlineGoogle } from 'react-icons/ai';

const SocialButtons = ({ signInWithGoogle, isPopupOpen, isGoogleAuthConfigured = true }) => (
    <div className="flex flex-col justify-center px-6 py-5 gap-2">
        <button
            onClick={signInWithGoogle}
            className={`flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border border-surface-200 dark:border-surface-700
                        bg-white dark:bg-surface-800 hover:bg-surface-50 dark:hover:bg-surface-700
                        text-sm font-medium text-surface-700 dark:text-surface-300 transition-all duration-200
                        ${(isPopupOpen || !isGoogleAuthConfigured) ? 'cursor-not-allowed opacity-60' : 'hover:shadow-md'}`}
            disabled={isPopupOpen || !isGoogleAuthConfigured}
        >
            <AiOutlineGoogle className="text-red-500 text-lg" />
            Continuar con Google
        </button>

        {!isGoogleAuthConfigured && (
            <p className="text-xs text-amber-600 dark:text-amber-400 text-center">
                Google Sign-In no esta disponible temporalmente.
            </p>
        )}
    </div>
);

export default SocialButtons;
